/**
 * @file Общие данные для всех экранов.
 *
 * Provider языка и Provider пользователя оборачивают маршруты, поэтому вход
 * и dashboard читают одни и те же значения через Context.
 */
import App from './App'
import { CustomerProvider } from './context/CustomerContext'
import type { OneTimeSignInAttempt } from './features/session/oneTimeSignIn'
import { LocaleProvider } from './i18n/LocaleProvider'

const Root = ({
    oneTimeSignIn,
}: {
    oneTimeSignIn: OneTimeSignInAttempt | null
}) => (
    <LocaleProvider>
        {/* null означает обычное открытие приложения — можно восстановить сессию.
            Объект означает вход по OTAT, даже если токен окажется некорректным:
            результат покажет экран входа, а старую сессию параллельно не читаем. */}
        <CustomerProvider restoreSession={oneTimeSignIn === null}>
            <App oneTimeSignIn={oneTimeSignIn} />
        </CustomerProvider>
    </LocaleProvider>
)

export default Root
